import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  Hospitalization: {
    ...genStandard("hospitalization", "/api/ip", false),
  },

  /*********** 记账记录 ***********/
  Billing: {
    ...genStandard("billing", "/api/ip"),
    sum: (para) => apiFuns.get(`/api/ip/billing/sum`, para),
    drugApply: (para) => apiFuns.put(`/api/ip/billing/drug/apply`, para),
    drugCancelApply: (para) => apiFuns.put(`/api/ip/billing/drug/cancelApply`, para),
    drugRefund: (para) => apiFuns.del(`/api/ip/billing/drug/refund`, para),
    drugCancelRefund: (para) => apiFuns.del(`/api/ip/billing/drug/cancelRefund`, para),
    drugSummary: (para) => apiFuns.get(`/api/ip/billing/drug/summary`, para),
  },
};

export default api;
